// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ytao","toggleWrap":"styles_toggleWrap__2slSO","content":"styles_content__9FV-O","selectAreaCode":"styles_selectAreaCode__3vtWE"};